<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div class="d-flex flex-row">
            <span class="iconsminds-pen mr-3 menu-icon-style" style="font-size: 23px;"/>

            <piaf-breadcrumb heading="Signatures Archived"/>

<!--            <p class="my-auto">-->
<!--                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                officiis quia quos rem totam vitae.-->
<!--            </p>-->
        </div>

        <div class="my-2">
            <div class="d-block d-md-inline-block pt-1">
                <b-dropdown :text="'Order by: ' + meta.order_by"
                            variant="outline-dark" class="mr-1 float-md-left btn-group" size="xs">

                    <b-dropdown-item v-for="(field,index) in table_fields.slice(0, -1)"
                                     v-if="field.sortable === true" :key="index"
                                     @click="changeOrderBy(field.key, field.label)">{{ field.label }}
                    </b-dropdown-item>
                </b-dropdown>

                <div class="search-sm d-inline-block float-md-left ml-1 align-top">
                    <b-input placeholder="Search" @input="searchSignature" v-model="meta.search"/>
                </div>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{meta.from}}-{{meta.to}} of {{ meta.total }}</span>

                <b-dropdown right :text="meta.per_page.toString()" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="separator mb-4"></div>

        <b-card class="mb-4" :title="'Signatures List'">
            <b-refresh-button class="text-data-link" @click="refreshData"/>

            <b-table :key="tableKey" show-empty no-sort-reset class="vuetable" :sort-by="meta.sort_by"
                     :sort-desc="meta.sort_desc" @sort-changed="changeSorting" :per-page="meta.per_page"
                     :current-page="meta.current_page" :fields="table_fields" :items="fetchSignatures">
                <template v-slot:cell(id)="data">
                    <router-link class="text-data-link" :to="data.item.links.self"
                                 v-text="data.item.data.attributes.code"/>
                </template>

                <template v-slot:cell(date)="data">
                    <span v-text="data.item.data.attributes.date"/>
                </template>

                <template v-slot:cell(facility)="data">
                    <span v-text="data.item.data.attributes.facility"/>
                </template>

                <template v-slot:cell(address)="data">
                    <span v-text="data.item.data.attributes.address"/>
                </template>

                <template v-slot:cell(total)="data">
                    <span v-text="data.item.data.attributes.total"/>
                </template>

                <template v-slot:cell(signed)="data">
                    <span v-text="data.item.data.attributes.signed"/>
                </template>

                <template v-slot:cell(sign_percentage)="data">
                    <span v-text="data.item.data.attributes.sign_percentage"/>
                </template>
            </b-table>

            <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                          v-model="meta.current_page">
                <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                </template>

                <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                </template>

                <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                </template>

                <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                </template>
            </b-pagination>
        </b-card>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "SignaturesArchivedList",

        data() {
            return {
                loading: true,
                signature: null,
                edit: false,
                tableKey: 0,
            }
        },

        computed: {
            ...mapGetters({
                table_fields: 'getSignatureArchivedTableFields',
                meta: 'getSignaturesArchivedMeta',
            })
        },

        methods: {
            fetchSignatures() {
                return this.$store.dispatch('fetchSignaturesArchived')
                    .then(signatures => {
                        return signatures.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            changeOrderBy(key, label) {
                this.meta.order_by = label;
                this.meta.sort_by = key;
            },

            searchSignature: _.debounce(function (event) {
                // if (this.meta.search && this.meta.search.length >= 3) {
                    this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
                // }
            }, 300),

            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            refreshData() {
                this.$store.commit('resetSignaturesArchivedMeta');
                this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
            },

            changeSorting(event) {
                (event.sortDesc ? this.meta.sort = 'desc' : this.meta.sort = 'asc') && (this.meta.sort_by = event.sortBy);
            },
        },
    }
</script>

<style scoped>

</style>
